// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"e2aab63a","598":"a3eec06d"}[chunkId] + ".chunk.js";
};